import React from "react";
import { INSPECTION_MODE } from "./inspectionStatus";

export function InspectionModeControls({
  mode,
  canInspectionMode,
  year,
  onYearChange,
  onlyUninspected,
  onOnlyUninspectedChange,
  onModeChange,
  error,
  truncated,
}) {
  const isInspection = mode === INSPECTION_MODE.inspection;

  return (
    <>
      <div className="map-controls__card inspection-mode-control">
        <button
          type="button"
          className={`inspection-mode-control__btn ${!isInspection ? "is-active" : ""}`}
          onClick={() => onModeChange(INSPECTION_MODE.normal)}
        >
          <span className="inspection-mode-control__icon" aria-hidden="true">О</span>
          Оддий
        </button>
        <button
          type="button"
          className={`inspection-mode-control__btn ${isInspection ? "is-active" : ""}`}
          onClick={() => canInspectionMode && onModeChange(INSPECTION_MODE.inspection)}
          disabled={!canInspectionMode}
          title={
            canInspectionMode
              ? "Кўрик назорати"
              : "Сизда ҳуқуқ йўқ"
          }
        >
          <span className="inspection-mode-control__icon" aria-hidden="true">К</span>
          Кўрик
        </button>
      </div>

      {isInspection && (
        <div className="map-controls__card inspection-toolbar">
          <label className="inspection-toolbar__field">
            <span>Йил</span>
            <input
              type="number"
              min="2000"
              max="2100"
              value={year}
              onChange={(e) => onYearChange(Number(e.target.value))}
            />
          </label>

          <label className="inspection-toolbar__check">
            <input
              type="checkbox"
              checked={onlyUninspected}
              onChange={(e) => onOnlyUninspectedChange(e.target.checked)}
            />
            <span>Фақат кўрикдан ўтмаганлар</span>
          </label>

          {truncated && <div className="inspection-toolbar__meta">Таянчлар жуда кўп, харитани яқинлаштиринг</div>}
          {error && <div className="inspection-toolbar__error">{error}</div>}
        </div>
      )}
    </>
  );
}
